// TODO: Refactor of types
import { cloneDeep } from "lodash";

import type { UserData } from "@/@types/global";
import type {
  UserPayPromisesPerDay,
  PayPromise,
  TotalPayPromisesPerUser,
  PayPromisesPerUser,
  Report,
} from "@/@types/reports/payPromise";

function groupByUser(rawData: UserPayPromisesPerDay[]): PayPromisesPerUser[] {
  const groupedData: PayPromisesPerUser[] = [];

  rawData.forEach((data) => {
    const userGroup = groupedData.find((row) => {
      const user = row.user as UserData;

      return user.id === data.user.id;
    });

    const { user, date, ...payPromise } = data;

    // userGroup.pay_promises.push(payPromise);
    if (userGroup) userGroup[date] = { ...payPromise, date };
    else groupedData.push({ user, [date]: { ...payPromise, date } });
  });

  return groupedData;
}

export function getRankingTotal(rawData: UserPayPromisesPerDay[]): Report {
  const totalRow: TotalPayPromisesPerUser = [{ date: "Total", total_amount: 0, total_pdp: 0 }];

  const groupedData = groupByUser(rawData);

  // const results = cloneDeep(groupedData);

  groupedData.forEach((row) => {
    const totalColumn: PayPromise = { total_amount: 0, total_pdp: 0, date: "Total" };

    for (const key in row) {
      const attribute = row[key] as PayPromise;

      totalColumn.total_amount += attribute.total_amount ?? 0;
      totalColumn.total_pdp += attribute.total_pdp ?? 0;
    }

    totalColumn.total_amount = Number(totalColumn.total_amount.toFixed(2));
    totalColumn.total_pdp = Number(totalColumn.total_pdp.toFixed(2));

    row["Total"] = totalColumn;
  });

  groupedData.forEach((row) => {
    for (const key in row) {
      const attribute = cloneDeep(row[key]) as PayPromise;

      const totalRowDay = totalRow.find((totalPromise) => totalPromise.date === attribute.date);

      if (totalRowDay) {
        totalRowDay.total_amount += attribute.total_amount ?? 0;
        totalRowDay.total_pdp += attribute.total_pdp ?? 0;
      } else {
        totalRow.push(attribute);
      }
    }
  });

  return { results: groupedData, total: totalRow };
}
